<template>
	<div class="zh_details_box" v-if="zhdata.length > 0">
		<el-dialog title="追号详情" :visible.sync="dialogVisible" width="985px" :lock-scroll="false">
			<div class="show_number">
				{{ zhdata[0].BetContent }}
			</div>
			<div class="bet_detail">
				<div class="pet_detail_left">
					<div class="detail_item">追号编号：{{ zhdata[0].ZhNumber }}</div>
					<div class="detail_item">追号彩种：{{ zhdata[0].LgName }}</div>
					<div class="detail_item">追号模式：{{ zhdata[0].AmName }}</div>
					<div class="detail_item">
						追号金额：<b>{{ zhdata[0].allMoney.toFixed(3) }}</b
						>元
					</div>
					<div class="detail_item">
						追号时间：<b>{{ zhdata[0].BetTime }}</b>
					</div>
				</div>
				<div class="pet_detail_right">
					<div class="detail_item">
						追号玩法：{{ zhdata[0].LpName
						}}<span v-if="zhdata[0].RxDsFormart != null">({{ zhdata[0].RxDsFormart }})</span>
					</div>
					<div class="detail_item">
						奖金返点：<b>{{ zhdata[0].BetBonus.toFixed(3) }}</b
						>元 | <b>{{ zhdata[0].BetRebate.toFixed(1) }}</b
						>%
					</div>
					<div class="detail_item">
						每单注数：<b>{{ zhdata[0].BetCount }}</b>
					</div>
					<div class="detail_item">中奖停止：{{ zhdata[0].IsZhWinStop ? "是" : "否" }}</div>
				</div>
			</div>
			<div class="after_no_tab">
				<!-- 追号详情表格 -->
				<el-table :data="zhdata" border stripe max-height="244" style="width: 100%" :cell-class-name="setTrackClass">
					<el-table-column type="index" :index="indexMethod" label="序号" width="50" />
					<el-table-column prop="Lssue" label="投注期号" width="160" />
					<el-table-column prop="CompleteTime" label="结束时间" width="175" />
					<el-table-column prop="OpenNumber" label="开奖号码" width="80" />
					<el-table-column prop="BetMultiple" label="倍数" width="50" />
					<el-table-column prop="BetMoney" label="投注金额" width="80" />
					<el-table-column prop="WinBonus" label="中奖金额" width="80" />
					<el-table-column prop="WinCount" label="中奖注数" width="80" />
					<el-table-column prop="KuiYing" label="亏盈" width="62">
						<template slot-scope="scope">
							<div v-if="scope.row.Status == 4 || scope.row.Status == 3">{{ scope.row.KuiYing }}</div>
							<div v-else>0</div>
						</template>
					</el-table-column>
					<el-table-column prop="StatusText" label="状态" width="70" />
					<el-table-column label="操作" width="70" align="center">
						<template slot-scope="scope">
							<div
								class="cancellations"
								v-if="scope.row.CanCancle && scope.row.Status == 1"
								@click="cancelOrder(scope.$index, zhdata)"
							>
								撤单
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="after_no_footer">
				<el-button type="primary" class="termination" v-if="calcSelf.canCancelAll" @click="stopOrder"
					>终止全部追号</el-button
				>
				<div>
					此次追号亏盈：<span class="w3">{{ calcSelf.totalKuiYing.toFixed(3) }}</span
					>元
				</div>
			</div>
		</el-dialog>
		<OrderCancel ref="zhOrderCancel" :confirm="cancelOrderConfirm">
			<template slot="content">
				<div>
					<span>您将撤销</span>
					<span>{{ cancelOrderTips }}</span>
					<span>追号订单</span>
				</div>
			</template>
		</OrderCancel>
	</div>
</template>
<script>
import { postAjax, getAjax } from "../../util/ajax.js";
import OrderCancel from "@/components/Elasticframe/OrderCancel";

export default {
	components: { OrderCancel },
	props: {
		zhdata: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			//自己计算的详情的总的金额和总的亏盈
			calcSelf: {
				canCancelAll: false,
				totalMoney: 0,
				totalKuiYing: 0,
			},
			cancelOrderType: 0,
			cancelOrderTips: "",
			curCancelOrder: null,
			dialogVisible: false,
		};
	},
	watch: {
		zhdata() {
			//计算总金额和总亏盈加序号字段
			let tempMoney = 0;
			let tempKuiYing = 0;
			// 订单状态
			// 0 未知  1 未开奖  2 已撤单  3 已中奖  4 未中奖
			this.calcSelf.canCancelAll = false;
			for (var i = 0, length = this.zhdata.length; i < length; i++) {
				tempMoney += this.zhdata[i].BetMoney;
				tempKuiYing += this.zhdata[i].KuiYing;
				this.zhdata[i].serialNum = i + 1;
				if (this.zhdata[i].Status === 1) {
					this.calcSelf.canCancelAll = true;
				}
			}
			this.calcSelf.totalMoney = tempMoney;
			this.calcSelf.totalKuiYing = tempKuiYing;
		},
	},
	methods: {
		closeThisDiv() {
			this.dialogVisible = false;
		},
		cancelOrderConfirm() {
			if (this.cancelOrderType === 1) {
				let url = "api/Bet/CancleOrder?number=" + this.curCancelOrder.OrderNumber + "&type=1";
				postAjax(url)
					.then(data => {
						if (data.Data == false) {
							this.openFail();
						} else if (data.Data == true) {
							let message = "已成功取消订单";
							this.openSucc(message);
						}
						this.$emit("list");
						this.$emit("getinfo");
					})
					.then(() => {
						this.dialogVisible = false;
					});
			} else if (this.cancelOrderType === 2) {
				let url = "api/Bet/CancleOrder?number=" + this.zhdata[0].ZhNumber + "&type=2";
				postAjax(url)
					.then(data => {
						if (data.Data == false) {
							this.openFail();
						} else if (data.Data == true) {
							let text = "成功取消所有追号";
							this.openSucc(text);
						}
					})
					.then(() => {
						this.$emit("list");
						this.$emit("getinfo");
						this.dialogVisible = false;
					});
			}
		},
		// 设置表头
		indexMethod(index) {
			return index + 1;
		},
		// 取消追号
		cancelOrder(index, data) {
			(this.cancelOrderType = 1), (this.curCancelOrder = data[index]);
			this.cancelOrderTips = `${this.curCancelOrder.LgName} ${this.curCancelOrder.Lssue}期`;
			this.$refs.zhOrderCancel.show();
		},
		//取消全部追号
		stopOrder() {
			(this.cancelOrderType = 2), (this.cancelOrderTips = `全部`);
			this.$refs.zhOrderCancel.show();
		},

		//设置追号数字样式
		setTrackClass({ columnIndex }) {
			if (columnIndex <= 8) {
				return "num";
			}
		},
	},
	created() {},
};
</script>
<style>
.zh_details_box .show_number {
	border: 1px solid #d7d7d7;
	height: 63px;
	padding: 10px 14px;
	overflow-y: auto;
	background-color: #ffffff;
	font-family: "HiraginoSansGB-W3";
}

.zh_details_box .bet_detail {
	padding-top: 4px;
	display: flex;
}

.zh_details_box .pet_detail_left,
.zh_details_box .pet_detail_right {
	width: 50%;
}

.zh_details_box .detail_item {
	line-height: 14px;
	margin-top: 16px;
}

.zh_details_box .detail_item > span {
	color: red;
}

.zh_details_box .detail_item > b {
	font-family: "HiraginoSansGB-W3";
	font-weight: 400;
}

.zh_details_box .after_no_tab {
	height: 244px;
	margin-top: 20px;
}

.zh_details_box .after_no_footer {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
}

.zh_details_box .cancellations {
	cursor: pointer;
	color: red;
}

.zh_details_box .el-table thead th {
	background-color: #f2f2f2;
	color: #333333;
}

.zh_details_box ::-webkit-scrollbar {
	display: none;
}

.zh_details_box .el-dialog {
	background-color: #ffffff;
}

.el-table .num {
	font-family: "HiraginoSansGB-W3";
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/zhdetails.vue